import React from "react"
import types from "prop-types"
import { useSelector } from "react-redux"
import { useCustomName } from "hooks"
import { getFormHasLocationQuestions } from "reduxSlices/formBuilderSlice"
import { DEPARTMENT_KEY, FACILITY_KEY } from "utils/customNameHelpers"
import { getActionOptions } from "utils/workflowHelpers"
import { IconSelect } from "shared/selects"
import SvgSpriteIcon from "shared/SvgSpriteIcon"

const renderContentIcon = ({ icon }) => icon && <SvgSpriteIcon iconName={icon} />
const itemRenderer = ({ item, methods }) => (
  <div
    className="flex items-center py-2.5"
    onClickCapture={() => methods.addItem(item)}
  >
    <SvgSpriteIcon iconName={item.icon} className="mx-2" />
    <span className="text-sm font-medium">{ item.label }</span>
  </div>
)

const SelectActionType = ({ changeActionType, value }) => {
  const formHasLocationQuestions = useSelector(getFormHasLocationQuestions)

  const facility = useCustomName(FACILITY_KEY)
  const department = useCustomName(DEPARTMENT_KEY)

  return (
    <IconSelect
      backspaceDelete={false}
      onChange={changeActionType}
      options={getActionOptions(formHasLocationQuestions, { facility, department })}
      style={{ height: "32px", minWidth: "200px" }}
      placeholder="Select action ... *"
      required
      renderContentIcon={renderContentIcon}
      itemRenderer={itemRenderer}
      value={value}
      selectLabel="select action"
    />
  )
}

SelectActionType.propTypes = {
  changeActionType: types.func.isRequired,
  value: types.string.isRequired,
}

export default SelectActionType
